import React from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import * as styles from './style';
import AddIcon from '../Icons/AddIcon';

const ScreenEmpty = props => {
  const { message, btnMessage, onClick, showButton } = props;
  return (
    <styles.ScreenEmpty className="screenEmpty">
      <styles.ScreenMessage>{message}</styles.ScreenMessage>
      {showButton && (
        <Button
          id="btn-add-menu"
          onClick={onClick}
          height="50px"
          customStyles={{
            margin: '30px auto 0',
            padding: '5px 15px',
            svg: { marginRight: '10px' },
          }}
        >
          <AddIcon color="#FFF" internBackGround="#4fa444" />
          {btnMessage}
        </Button>
      )}
    </styles.ScreenEmpty>
  );
};

ScreenEmpty.propTypes = {
  message: PropTypes.string,
  btnMessage: PropTypes.string,
  btnClass: PropTypes.string,
  onClick: PropTypes.func,
  showButton: PropTypes.bool,
};

ScreenEmpty.defaultProps = {
  showButton: true,
};

export default ScreenEmpty;



// WEBPACK FOOTER //
// ./src/components/ScreenEmpty/index.js